import { render } from "./AccountInvoices.vue?vue&type=template&id=4a192e4a"
const script = {}

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__